module.exports = "/assets/ce7a5318ec311a1429c48a242fc5326c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ST.png
// module id = 1833
// module chunks = 0